module.exports = __webpack_public_path__ + "img/default.b55241e2.png";